module.exports = __webpack_public_path__ + "static/img/advertise-mobile-image.64536a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/advertise-mobile-image.png
// module id = Jgfp
// module chunks = 1